import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    baseUrl: String,
    updateNow: { type: Boolean, default: false },
  }

  connect() {
    if (this.updateNowValue) {
      this.update()
    }
  }

  async update() {
    try {
      const currentUrl = new URL(window.location.href)
      const searchParams = currentUrl.searchParams

      const newUrl = new URL(this.baseUrlValue, window.location.origin)

      for (const [key, value] of searchParams.entries()) {
        newUrl.searchParams.set(key, value)
      }

      const response = await fetch(newUrl.toString(), {
        headers: {
          Accept: "text/html",
          "Turbo-Frame": "content",
        },
        redirect: "follow",
      })

      const html = await response.text()

      const parser = new DOMParser()
      const doc = parser.parseFromString(html, "text/html")

      const newTable = doc.querySelector(".h-data-table")
      const oldTable = document.querySelector(".h-data-table")

      if (newTable && oldTable) {
        const newTbody = newTable.querySelector("tbody")
        const oldTbody = oldTable.querySelector("tbody")

        if (newTbody && oldTbody) {
          oldTbody.innerHTML = newTbody.innerHTML
        } else {
          oldTable.parentElement.replaceChild(newTable, oldTable)
        }

        window.dispatchEvent(new CustomEvent("leads:table-updated"))
      }
    } catch (error) {
      console.error("Error updating leads list:", error)
    }
  }
}
